import BaseApp from '../BaseApp.vue'
import App from './App.vue'
import { createApp } from 'vue'
import api from '../../plugins/api.js';
import message from '../../plugins/message.js';


const app = createApp(App, window[App.name+'Data']);
app.use(api);
app.use(message);
app.mount('#'+BaseApp.methods.pascalCaseToKebab(App.name))